import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import type { PropertyArchivePreflightResponse, PropertyResponse } from '@/shared/api';
import { ManualBookingPanel } from '../manual-booking';
import { PauseResumeDialog } from '../lifecycle/PauseResumeDialog';
import { ArchivePropertyDialog } from './ArchivePropertyDialog';

interface Props {
  property: PropertyResponse;
  readOnly: boolean;
  lifecycleAction: 'pause' | 'resume' | null;
  manualBookingOpen: boolean;
  onManualBookingChange: (open: boolean) => void;
  lifecycleOpen: boolean;
  onLifecycleChange: (open: boolean) => void;
  lifecycleMutation: UseMutationResult<unknown, Error, 'pause' | 'resume'>;
  archiveOpen: boolean;
  onArchiveChange: (open: boolean) => void;
  preflight: UseQueryResult<PropertyArchivePreflightResponse>;
  archive: UseMutationResult<unknown, Error, string | undefined>;
}

/** Die drei Overlays der Apartmentakte, gebündelt damit das Gerüst Struktur bleibt (§4). */
export function ApartmentDetailDialogs({
  property,
  readOnly,
  lifecycleAction,
  manualBookingOpen,
  onManualBookingChange,
  lifecycleOpen,
  onLifecycleChange,
  lifecycleMutation,
  archiveOpen,
  onArchiveChange,
  preflight,
  archive,
}: Props) {
  return (
    <>
      {property.channexPropertyId && !readOnly && (
        <ManualBookingPanel
          open={manualBookingOpen}
          onOpenChange={onManualBookingChange}
          apartment={{ property }}
        />
      )}

      {lifecycleAction && (
        <PauseResumeDialog
          open={lifecycleOpen}
          onOpenChange={onLifecycleChange}
          intent={lifecycleAction}
          propertyName={property.name}
          pending={lifecycleMutation.isPending}
          onConfirm={() =>
            lifecycleMutation.mutate(lifecycleAction, {
              onSuccess: () => onLifecycleChange(false),
            })
          }
        />
      )}

      <ArchivePropertyDialog
        open={archiveOpen}
        onOpenChange={onArchiveChange}
        propertyName={property.name}
        preflight={preflight.data}
        loading={preflight.isLoading}
        error={
          preflight.error ? 'Die Voraussetzungen konnten nicht sicher geprüft werden.' : undefined
        }
        archiving={archive.isPending}
        onConfirm={async (reason) => {
          await archive.mutateAsync(reason);
        }}
      />
    </>
  );
}
